<template>
  <modal :showCloseIcon="true" @send="add" v-on="$listeners">
    <div slot="header" class="emphasize">Add Nominee</div>
    <div slot="body">
      <div class="row">
        <div class="col-sm-6">
          <dropdown
            v-model="type"
            :required="true"
            label="Nominee Type*"
            :useDefaultIcon="true"
            :validate="doValidate"
            :options="nomineeStatus"
            @validated="setValidationResult('type',$event)"
          />
        </div>
        <div class="col-sm-6">
          <dropdown
            label="Gender*"
            :required="true"
            v-model="gender"
            :options="genderType"
            :useDefaultIcon="true"
            :validate="doValidate"
            @validated="setValidationResult('gender',$event)"
          />
        </div>
        <!-- <div class="col-sm-6">
            <ttw-input disabled="disabled" label="Title" v-model="title" />
        </div>-->
        <div class="col-sm-12">
          <ttw-input
            maxlength="35"
            :required="true"
            label="Last Name*"
            v-model="lastName"
            :validate="doValidate"
            :key-validator="isLetter"
            :input-validator="validateName"
            placeholder="Please Enter Last Name"
            @validated="setValidationResult('lastName',$event)"
          />
        </div>
        <div class="col-sm-12">
          <ttw-input
            maxlength="35"
            :required="true"
            v-model="firstName"
            label="First Name*"
            :validate="doValidate"
            :key-validator="isLetter"
            :input-validator="validateName"
            placeholder="Please Enter First Name"
            @validated="setValidationResult('firstName',$event)"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <ttw-datepicker
            :max="expMin"
            :min="minDob"
            v-model="dob"
            :required="true"
            label="Date of birth*"
            :validate="doValidate"
            @validated="setValidationResult('dob',$event)"
          />
        </div>
        <div class="col-sm-6">
          <dropdown
            :required="true"
            label="Nationality*"
            :options="countries"
            v-model="nationality"
            :useDefaultIcon="true"
            :validate="doValidate"
            @validated="setValidationResult('nationality',$event)"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <ttw-input
            v-model="passportNo"
            :validate="doValidate"
            label="Passport Number"
            placeholder="Passport Number"
            :key-validator="isAlphabetKey"
            :input-validator="validatePassport"
            @validated="setValidationResult('passportNo',$event)"
          />
        </div>
        <div class="col-sm-6">
          <ttw-datepicker
            :min="expMin"
            v-model="passportExp"
            :validate="doValidate"
            label="Passport Expiry Date"
            @validated="setValidationResult('passportExp',$event)"
          />
        </div>
      </div>
      <div class="row">
        <p class="col-xs-12 blue-font">*Adding of new nominee requires HR'S approval.</p>
        <div class="col-xs-12">
          <ttw-button @click="add" value="Add" />
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import moment from "moment";
import { mapMutations, mapState } from "vuex";
import Modal from "@/components/layout/Modal";
import { toKeyValueArray } from "../../core/tools";
import { getTitle, get30YearDate } from "../../core/staff-helper";
import { gender, genderMap,nomineeType } from "../../core/enum";
import {
  isAlphabetKey,
  isLetter,
  validateName,
  validatePassport
} from "../../core/validator";
import ValidationManager from "../../components/base/validation-manager";
export default {
  extends: Modal,
  mixins: [ValidationManager],
  components: {
    Modal
  },
  props: {
    startYear: {
      default: new Date().getFullYear()
    },
    nomineeStatus: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.gender = gender.male;
  },
  data() {
    return {
      dob: null,
      type: null, // Spouse / Friend / Child / Parent
      gender: null,
      title: null,
      lastName: null,
      firstName: null,
      passportNo: null,
      nationality: null,
      passportExp: null,
      expMin: moment()
        .add(-7, "days")
        .format("YYYY-MM-DD"),
    };
  },
  watch: {
    gender(val) {
      this.title = getTitle(this.dob, val);
    },
    dob(val) {
      this.title = getTitle(val, this.gender);
    },
    type(){
      this.dob = null;
    }
  },
  methods: {
    add() {
      this.commit(() =>
        this.$staff
          .addNominee(this.token, {
            dob: this.dob,
            title: this.title,
            staffId: this.staffId,
            lastName: this.lastName,
            firstName: this.firstName,
            expiryDate: this.passportExp,
            nationality: this.nationality,
            passportNumber: this.passportNo,
            gender: parseInt(this.gender, 10),
            nominee_type: parseInt(this.type, 10),
            startYear: parseInt(this.startYear, 10)
          })
          .then(() => {
            let tasks = [
              this.$staff.getNominees(this.token).then(r => {
                this.setNominees(r.data);
                this.$emit("complete");
              })
            ];
            this.financialYears.forEach(x =>
              tasks.push(
                this.$staff
                  .getSummary(x)
                  .then(r =>
                    this.setAvailableNominees({ year: x, data: r.data })
                  )
              )
            );
            return Promise.all(tasks);
          })
          .catch(ex =>
            this.setMessagePopup({
              title: this.$text.errorMessageTitle,
              message: ex?.response?.data?.Description?? ex.message
            })
          )
      );
    },
    isLetter: isLetter,
    validateName: validateName,
    isAlphabetKey: isAlphabetKey,
    validatePassport: validatePassport,
    ...mapMutations([
      "setBookings",
      "setNominees",
      "setMessagePopup",
      "setAvailableNominees"
    ])
  },
  computed: {
    genderType: () => toKeyValueArray(genderMap),
    minDob(){
      if(parseInt(this.type, 10) === nomineeType.childOfEmployee ){
        return get30YearDate().format("YYYY-MM-DD");
      }  
      return null;
    },
    ...mapState({
      token: s => s.token,
      staffId: s => s.userInfo?.staffId,
      financialYears: s => s.financialYears,
      countries: s =>
        toKeyValueArray(s.countries, null, x => x.name).sort((a, b) =>
          a.value === "Taiwan"
            ? -1
            : a.value.charCodeAt(0) - b.value.charCodeAt(0)
        )
    })
  }
};
</script>
<style lang="scss" scoped>
.form-group {
  width: 100%;
}
</style>